import React from 'react';
import PageTitle from 'modules/common/components/PageTitle';
import Uploader from 'modules/common/components/Uploader';
import ErrorLabel from 'modules/common/components/ErrorLabel';
import personImage from 'assets/images/illustrations/person.svg';
import { Controller, useForm } from 'react-hook-form';
import { isDesktop, storage } from 'modules/common/helper';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'modules/common/input';
import { IconCamera } from 'modules/common/icons';
import { Image } from 'modules/common/Img';
import { useHistory, useLocation } from 'react-router-dom';
import { schema, INIT_FORM } from './constants';

function TakePhoto() {
  const photo = storage.get('photo');
  const [isLoading, setIfLoading] = React.useState(false);
  const [uploading, setUploadoing] = React.useState(false);
  const { state } = useLocation();
  const is_edit = !!state?.is_edit;

  const history = useHistory();
  const {
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...INIT_FORM,
      ...photo,
    },
    resolver: yupResolver(schema),
  });

  const handleOnSubmit = (form) => {
    setIfLoading(true);
    setTimeout(() => {
      setIfLoading(false);
      storage.set('photo', form);
      history.push('/register/review-details');
    }, 500);
  };

  const handleIfLoading = (value) => {
    setUploadoing(value);
  };

  const renderTitle = () => {
    if (is_edit) {
      return 'Submit';
    }
    if (watch('photo')) {
      return 'Review Details';
    }
    return 'Next';
  };

  React.useEffect(() => () => history.replace({ state: '' }), [history]);

  return (
    <>
      <PageTitle title="Take Photo | Manila E-Citizen" />
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="space-y-8">
          <p className="text-primary-500 font-medium">Take a Photo</p>
          <div className="flex justify-center">
            <div className="w-1/2">
              <div className="relative flex justify-center">
                <Image
                  height="h-72"
                  containerClassName="bg-white"
                  className="object-contain"
                  src={watch('photo')}
                  defaultSrc={personImage}
                />
                {errors?.photo && (
                  <div className="absolute right-0 -bottom-1">
                    <ErrorLabel error={errors?.photo} />
                  </div>
                )}
              </div>
              <Controller
                render={({ field: { onChange } }) => (
                  <Uploader
                    className="btn primary md mt-5"
                    label={watch('photo') ? 'Retake photo' : 'Take Photo'}
                    crop="face"
                    tabs={['camera', 'file']}
                    icon={<IconCamera className="h-6 w-6 text-white mr-1" />}
                    isLoading={handleIfLoading}
                    onChange={(data) => {
                      const ext = data?.name.split('.').pop();
                      const cdn = `${data?.cdnUrl}/#.${ext}`;
                      onChange(cdn);
                    }}
                    autoFocus={isDesktop()}
                  />
                )}
                name="photo"
                control={control}
              />
            </div>
          </div>
          <div className="text-xs leading-relaxed">
            <p>Note:</p>
            <p>Application will not be processed if:</p>
            <ul className="list-inside list-decimal">
              <li>Photo does not resemble applicant</li>
              <li>Applicant wears eyeglasses </li>
              <li>Ears are covered </li>
              <li>No proper lighting</li>
            </ul>
          </div>
          <Button
            type="submit"
            isLoading={isLoading}
            disabled={isLoading || uploading}
            className="btn primary md font-base text-sm"
            label={renderTitle()}
          />
        </div>
      </form>
    </>
  );
}
TakePhoto.defaultProps = {};

TakePhoto.propTypes = {};

export default TakePhoto;
